/* eslint-disable import/no-anonymous-default-export */
import { FormService } from '../services'

export default (formData) => {
	return new Promise(resolve => {
		FormService.requestMatchFile(formData)
			.then(response => resolve(response.data))
	})
}
